export interface PreviewFile { url: string; name: string }
export const canPreviewDocument = (name: string) => /\.(pdf|docx|xlsx|txt|csv|tsv|md|json|log)$/i.test(name);
export async function readPreviewFile(url: string, signal: AbortSignal) {
  const resolved = new URL(url, window.location.href);
  if (resolved.origin !== window.location.origin && resolved.protocol !== 'blob:') throw new Error('Этот файл находится на другом сервере. Используйте «Скачать».');
  const response = await fetch(resolved, { signal, credentials: 'same-origin' });
  if (!response.ok) throw new Error('Не удалось получить файл. Возможно, он удалён или нет доступа.');
  const limit = 40 * 1024 * 1024;
  if (Number(response.headers.get('content-length')) > limit) throw new Error('Для просмотра файлов больше 40 МБ используйте «Скачать».');
  const reader = response.body?.getReader(); if (!reader) throw new Error('Не удалось прочитать файл.');
  const chunks: Uint8Array<ArrayBuffer>[] = []; let size = 0;
  while (true) { const { done, value } = await reader.read(); if (done) break; size += value.length;
    if (size > limit) { await reader.cancel(); throw new Error('Для просмотра файлов больше 40 МБ используйте «Скачать».'); }
    chunks.push(new Uint8Array(value));
  }
  return new Blob(chunks);
}
